module.exports = __webpack_public_path__ + "static/media/carolina.392f84eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/carolina.png
// module id = 338
// module chunks = 0